<template>
  <div class="mantle" v-if="is_open">
    <div class="mantle-content" :style="`background-image: url('${IMG_URL}images/mantle_bg2.png')`">
      <img class="close-btn" :src="IMG_URL+'/images/close.png'" alt="" @click="close(1)">
      <img class="vcode-icon" :src="API_URL+site.weixin_qrcode" alt="">
      <div class="footer-button">
        <div class="btn" @click="close(0)"></div>
        <div class="btn" @click="close(1)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mantle",
  data(){
    return{
      is_open: false
    }
  },
  computed:{
    site(){
      return this.$store.getters.site;
    }
  },
  methods:{
    open(){
      this.is_open = true;
    },
    close(type){
      if(type === 0){
        localStorage.setItem("addedWx", true);
      }
      this.is_open = false;
    }

  }
}
</script>

<style scoped>
.mantle{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0,0,0,0.5);

}
.mantle-content{
  width: 380px;
  height: 600px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

}
.vcode-icon{
  width: 180px;
  height: 180px;
  position: absolute;
  left: 50%;
  bottom: 138px;
  transform: translate(-50%, 0);
}
.close-btn{
  width: 35px;
  height: 35px;
  position: absolute;
  right: 10px;
  top: 20px;
  cursor: pointer;
}
.footer-button{
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translate(-50%, 0);
}
.footer-button .btn{
  width: 150px;
  cursor: pointer;
  height: 60px;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mantle/index.vue